






























import {
  defineComponent, ref, watch, getCurrentInstance,
} from '@vue/composition-api'
import {
  format, addMonths, parseISO,
} from 'date-fns'
import { mdiCalendar } from '@mdi/js'
import { DATE_FORMAT, useDateRange } from '@/views/v2-temp/common/composables/useDateRange'

export default defineComponent({
  name: 'DateRangePicker',
  props: {
    value: {
      type: Array as () => string[],
      required: true,
    },
    label: {
      type: String,
      default: '期間',
    },
    maxDate: {
      type: String,
      default: () => format(addMonths(new Date(), 1), DATE_FORMAT),
    },
    updateQuery: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const menu = ref(false)
    const {
      dateRange, displayRange, setDateRange,
    } = useDateRange(props.value[0], props.value[1])
    const { proxy } = getCurrentInstance()!

    watch(() => props.value, (newValue: string[]) => {
      setDateRange(newValue)
    })

    const formatDay = (date: string): string => {
      return format(parseISO(date), 'd')
    }

    const onDateRangeChange = (dates: string[]) => {
      setDateRange(dates)
      menu.value = false

      emit('input', dateRange.value)

      // URLクエリパラメータの更新
      if (props.updateQuery) {
        const query = {
          ...proxy.$route.query,
          start_date: dateRange.value[0],
          end_date: dateRange.value[1],
        }
        proxy.$router.replace({ query })
      }
    }

    return {
      menu,
      dateRange,
      displayRange,
      formatDay,
      onDateRangeChange,
      icons: {
        mdiCalendar,
      },
    }
  },
})
